var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadinline = function SvgDownloadinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.438 32.938a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z",
    stroke: "#3C3C64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.438 20.188v8.5M24.438 28.688 21.25 25.5M24.438 28.688l3.187-3.188M5.313 9.563h14.875M5.313 15.938h8.5M5.313 22.313h5.312",
    stroke: "#7D64FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 28.688H3.187a2.125 2.125 0 0 1-2.124-2.125V3.188a2.125 2.125 0 0 1 2.125-2.126h15.057c.563 0 1.104.224 1.502.622l4.069 4.07c.398.397.621.938.622 1.5v3.371",
    stroke: "#3C3C64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDownloadinline;